import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TabIdGeneratorService {
  constructor() { }

  generateNewTabId(): string {
    return this.randomHexString(6);
  }

  private randomHexString(length: number): string {
    const maxLength = 8;
    const min =  Math.pow(16, Math.min(length, maxLength) - 1);
    const max = Math.pow(16, Math.min(length, maxLength)) - 1;
    const n = Math.floor(Math.random() * (max - min + 1)) + min;
    let hex = n.toString(16);

    while (hex.length < length) {
      hex += this.randomHexString(length - maxLength);
    }

    return hex;
  }
}
